import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import Navigation from 'hb-react/shared/apps/Memberships/containers/PurchaseMembership/components/Navigation';
import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/useShoppingCard';
import { useShoppingCardContext } from 'hb-react/shared/components/ShoppingCard/ShoppingCardContext';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const NavBarDesktop = ({
  onCancel,
  onNext,
  registrationSubmitButtonText,
  isNextDisabled = false,
}) => (
  <>
    <Button
      variant="secondary"
      mr={2}
      icon={() => (
        <FontAwesomeIcon
          iconName="chevron-left"
          height="16px"
          iconType={CATEGORIES.SOLID}
        />
      )}
      size="small"
      onClick={onCancel}
    >
      {s__('Memberships|Cancel purchase')}
    </Button>
    <Button onClick={onNext} isDisabled={isNextDisabled}>
      {registrationSubmitButtonText}
    </Button>
  </>
);

const NavBarMobile = ({
  toggleModal,
  onCancel,
  onNext,
  isNextDisabled = false,
}) => {
  const { flagEvOrderSummaryDsMemberships } = useFeatureFlag();

  return (
    <Box flexDirection="column" width="100%" justifyContent="space-between">
      {flagEvOrderSummaryDsMemberships ? null : (
        <Box alignItems="center" mb={2}>
          <Button variant="inversed" onClick={toggleModal}>
            {s__('ShoppingCard|Order Summary')}
          </Button>
        </Box>
      )}
      <Box alignSelf="flex-end">
        <Button variant="secondary" mr={2} onClick={onCancel}>
          {__('Back')}
        </Button>
        <Button onClick={onNext} isDisabled={isNextDisabled}>
          {s__('ShoppingCard|Proceed')}
        </Button>
      </Box>
    </Box>
  );
};

export const NavBar = (props) => {
  const { toggleModal } = useShoppingCardContext();
  const { isLoading } = useShoppingCard();

  return (
    <Navigation>
      {({ isFixed }) =>
        isFixed ? (
          <NavBarMobile
            toggleModal={toggleModal}
            {...props}
            isNextDisabled={isLoading}
          />
        ) : (
          <NavBarDesktop {...props} isNextDisabled={isLoading} />
        )
      }
    </Navigation>
  );
};
